/**
 * Schema of OcultarNotasResponsavel
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import OcultarNotasResponsavel from '@/model/resource/OcultarNotasResponsavel'

export default (model: OcultarNotasResponsavel): Schema => ({
  idOcultarNotasResponsavelPk: {
    content: model.idOcultarNotasResponsavelPk,
    editable: false,
  },

  razaoSocial: {
    content: model.razaoSocial,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  cnpj: {
    content: model.cnpj,
    input: InputType.CPF_OR_CNPJ,
    meta: {
      required: true,
      maxlength: '14',
    },
  },

  idResponsavelFk: {
    content: model.idResponsavelFk,
    input: InputType.TEXT,
  },

  ativo: {
    content: bool(model.ativo),
    input: InputType.CHECKBOX,
  },
})
